module.exports = __webpack_public_path__ + "img/blueinfo.c1affee6.svg";